// Pure client-side filter + sort helpers for the Notice list. Kept separate
// from React Query/Zustand so they can be unit-tested without a renderer.
// Server-side support is an open question (contract §4 Q1).

import type { NoticeSummary } from '../types/notices.types';
import type { NoticeSortKey, SortDir } from '../store/notices-page.store';

// PRD 13 §3.1 — search matches title + author name (case-insensitive
// substring). Mirrors the prototype, which filters on title || author.
export function filterNotices(rows: NoticeSummary[], search: string): NoticeSummary[] {
  const needle = search.trim().toLowerCase();
  if (!needle) return rows;
  return rows.filter((row) => {
    const haystack = [row.title, row.author.name].join(' ').toLowerCase();
    return haystack.includes(needle);
  });
}

// `id` and `views` sort numerically; everything else (audience/title/category/
// status code, createdAt ISO string) sorts lexicographically — matching the
// prototype's comparator.
export function sortNotices(
  rows: NoticeSummary[],
  key: NoticeSortKey,
  dir: SortDir,
): NoticeSummary[] {
  const copy = rows.slice();
  copy.sort((a, b) => {
    if (key === 'id' || key === 'views') {
      const cmp = a[key] - b[key];
      return dir === 'asc' ? cmp : -cmp;
    }
    const cmp = String(a[key] ?? '').localeCompare(String(b[key] ?? ''));
    return dir === 'asc' ? cmp : -cmp;
  });
  return copy;
}
